import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import ButtonDeprecated, {
  BUTTON_THEME_GREEN_ADOBE_FLEX,
  BUTTON_THEME_GREY_ADOBE_FLEX,
} from 'client/components/ButtonDeprecated';
import SrStaticFooter from 'client/components/SrStaticFooter';
import SrText from 'client/components/SrText';
import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';

const SrPageFooterYesNo = ({
  onBack,
  onNext,
}) => {

  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  return (
    <SrStaticFooter>
      <SrText
        display={isSmallScreen ? 'none' : 'block'}
        lineHeight='25px'
        font='greycliff'
        color='grey600'
        fontSize='13px'
        weight='500'
      >
        Full-Service leasing with Sunroom
      </SrText>
      <SrBox width={isSmallScreen ? '100%' : '456px'}>
        <SrFlex wrap='nowrap' width={isSmallScreen ? '100%' : 'auto'}>
          <ButtonDeprecated
            theme={BUTTON_THEME_GREY_ADOBE_FLEX}
            onClick={onBack}
            width={isSmallScreen ? 'calc(50vw - 11px)' : '220px'}
            margin={isSmallScreen ? '0 8px 0 0' : '0 16px 0 0'}
          >
            No
          </ButtonDeprecated>
          <ButtonDeprecated
            theme={BUTTON_THEME_GREEN_ADOBE_FLEX}
            hasBoxShadow
            onClick={onNext}
            width={isSmallScreen ? 'calc(50vw - 11px)' : '220px'}
          >
            Yes
          </ButtonDeprecated>
        </SrFlex>
      </SrBox>
    </SrStaticFooter>
  );
};

SrPageFooterYesNo.propTypes = {
  onBack: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
};

SrPageFooterYesNo.displayName = 'SrPageFooterYesNo';

export default SrPageFooterYesNo;
